// extracted by mini-css-extract-plugin
export default {"ag-styles":"F_g","detailCellRenderer":"F_cT"};